/**
 *      ev05_fig.js
 *          Script de ev02_16pf.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */
/* ======================================================================================================== */
import moment from 'moment'
import ingreso from './ingreso.vue'

import Vue from 'vue';
import jsPDF from 'jspdf'
Vue.use(jsPDF)

import { store } from './../store/store'

// import 'materialize-css/dist/css/materialize.min.css'
import M from 'materialize-css'

export default {
     name: 'perfil',
     components: {
          'moment': moment,
          'input-date': ingreso,
     },
     template: `#formafig`,
     data() {
          return {
               ejemplo: {},
               eval_fig: {}, res_fig: {},
               modo: "",
               eval_fecha: new Date(),
               instrucciones: "",
               inicioeval: false, finalizoeval: false, grabado: false,
               pregSinContestar: 0, ejeSinResponder: 0,

               //? .....................................................................................................................................................................................................................
               activott1:"active", activott2: '!active', activott3: "!active", activott4:"!active", 
               vertt1: true, vertt2: false, vertt3: false, vertt4: false, 
               area1: "", area2: '', area3: '', area4: "", 

          } // return
     }, // data()
     mounted() {

          /** Definiciones para el uso de los slides y tooltips */
          var elems = document.querySelectorAll('.collapsible');
          var instances = M.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = M.Tooltip.init(elems, {});

          var elem = document.querySelectorAll('.tabs');
          var instances = M.Tabs.init(elem, {});

          /** obtiene localmente el caso definido en el almacén (store) */
          this.cargaEvaluacion();
     },
     computed: {
          l_sinResponder() {
               return this.sinContestar();
          },
          l_ejeSinResponder() {
               return this.ejeSinContestar();
          },
     },
     methods: {

          crearPDF() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_fig.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "fig_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de PERFIL DE PERSONALIDAD para " + this.eval_fig.nombre + " de " + this.eval_fig.empresa + " ( " + this.eval_fig.depto + " )");

               this.respuestas(doc);
               this.resultados(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          rangosfig(){

               this.res_fig = {
                    mas_D: 0, menos_D: 0, mas_I: 0, menos_I: 0, mas_S: 0, menos_S: 0,
                    mas_C: 0, menos_C: 0, mas_N: 0, menos_N: 0, mas_W: 0, menos_W: 0,
                    total_mas: 0, total_menos: 0,
               };

               switch (this.eval_fig.pg001) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 2 */
               switch (this.eval_fig.pg002) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 3 */
               switch (this.eval_fig.pg003) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_fig.pg004) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 5 */
               switch (this.eval_fig.pg005) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N+': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 6 */
               switch (this.eval_fig.pg006) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 7 */
               switch (this.eval_fig.pg007) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 8 */
               switch (this.eval_fig.pg008) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 1 */
               switch (this.eval_fig.pg009) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 2 */
               switch (this.eval_fig.pg010) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 11 */
               switch (this.eval_fig.pg011) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N+': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 12 */
               switch (this.eval_fig.pg012) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 13 */
               switch (this.eval_fig.pg013) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 14 */
               switch (this.eval_fig.pg014) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 15 */
               switch (this.eval_fig.pg015) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N+': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 16 */
               switch (this.eval_fig.pg016) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    case 'N+': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 17 */
               switch (this.eval_fig.pg017) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 18 */
               switch (this.eval_fig.pg018) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 19 */
               switch (this.eval_fig.pg019) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 11 */
               switch (this.eval_fig.pg020) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 12 */
               switch (this.eval_fig.pg021) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 18 */
               switch (this.eval_fig.pg022) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 23 */
               switch (this.eval_fig.pg023) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 24 */
               switch (this.eval_fig.pg024) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 25 */
               switch (this.eval_fig.pg025) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 26 */
               switch (this.eval_fig.pg026) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 27 */
               switch (this.eval_fig.pg027) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 28 */
               switch (this.eval_fig.pg028) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    case 'N+': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 29 */
               switch (this.eval_fig.pg029) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 30 */
               switch (this.eval_fig.pg030) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 31 */
               switch (this.eval_fig.pg031) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 32 */
               switch (this.eval_fig.pg032) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 33 */
               switch (this.eval_fig.pg033) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 34 */
               switch (this.eval_fig.pg034) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 35 */
               switch (this.eval_fig.pg035) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 36 */
               switch (this.eval_fig.pg036) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    case 'N+': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 37 */
               switch (this.eval_fig.pg037) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 38 */
               switch (this.eval_fig.pg038) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 39 */
               switch (this.eval_fig.pg039) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 40 */
               switch (this.eval_fig.pg040) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 41 */
               switch (this.eval_fig.pg041) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 42 */
               switch (this.eval_fig.pg042) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 43 */
               switch (this.eval_fig.pg043) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 44 */
               switch (this.eval_fig.pg044) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 45 */
               switch (this.eval_fig.pg045) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 46 */
               switch (this.eval_fig.pg046) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 47 */
               switch (this.eval_fig.pg047) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 48 */
               switch (this.eval_fig.pg048) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }

               this.res_fig.total_mas = this.res_fig.mas_D + this.res_fig.mas_I + this.res_fig.mas_S + this.res_fig.mas_C + this.res_fig.mas_N;
               this.res_fig.total_menos = this.res_fig.menos_D + this.res_fig.menos_I + this.res_fig.menos_S + this.res_fig.menos_C + this.res_fig.menos_N;

          },
          resultados(doc) {

               this.rangosfig();

               console.log("***-*-*-*-****---*******");
               console.log("resultados ? ",this.res_fig);
               doc.setLineWidth(0.25);

               doc.text(10, 88, "SECCION DE RESULTADOS ")
               doc.line(10, 89, 206, 89);

               let menos_D = this.res_fig.menos_D;
               let mas_D   = this.res_fig.mas_D;
               let difD    = mas_D - menos_D;
               doc.text(20, 94, "MAS"); doc.text(30, 94, "MENOS"); doc.text(50, 94, "DIFERENCIA");
               doc.text(20, 96, "-------"); doc.text(30, 96, "-----------"); doc.text(50, 96, "-------------------");
               doc.text(10, 100, "D");   
               doc.text(22, 100, mas_D.toString()); doc.text(35, 100, menos_D.toString()); doc.text(57, 100, difD.toString());

               let menos_I = this.res_fig.menos_I;
               let mas_I = this.res_fig.mas_I;
               let difI = mas_I - menos_I;
               doc.text(10, 105, "I");
               doc.text(22, 105, mas_I.toString()); doc.text(35, 105, menos_I.toString()); doc.text(57, 105, difI.toString());

               let menos_S = this.res_fig.menos_S;
               let mas_S = this.res_fig.mas_S;
               let difS = mas_S - menos_S;
               doc.text(10, 110, "S");
               doc.text(22, 110, mas_S.toString()); doc.text(35, 110, menos_S.toString()); doc.text(57, 110, difS.toString());

               let menos_C = this.res_fig.menos_C;
               let mas_C = this.res_fig.mas_C;
               let difC = mas_C - menos_C;
               doc.text(10, 115, "C");
               doc.text(22, 115, mas_C.toString()); doc.text(35, 115, menos_C.toString()); doc.text(57, 115, difC.toString());

               let menos_N = this.res_fig.menos_N;
               let mas_N = this.res_fig.mas_N;
               let difN = mas_N - menos_N;
               doc.text(10, 120, "N");
               doc.text(22, 120, mas_N.toString()); doc.text(35, 120, menos_N.toString()); doc.text(57, 120, difN.toString());
               doc.text(20, 122, "-------"); doc.text(30, 122, "-----------"); doc.text(50, 122, "-------------------");

               let total_mas = 0; let total_menos= 0;
               total_mas = mas_D + mas_I + mas_S + mas_C + mas_N;
               total_menos = menos_D + menos_I + menos_S + menos_C + menos_N;
               doc.text(22, 125, total_mas.toString()); doc.text(35, 125, total_menos.toString()); 
               
          },
          respuestas(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ")
               doc.line(10, 42, 190, 42);
               doc.text(10, 45, "01= "); 
               doc.text(23, 45, this.eval_fig.pg001); 
               doc.text(30, 45, "03= "); 
               doc.text(43, 45, this.eval_fig.pg003);
               doc.text(50, 45, "05= "); 
               doc.text(63, 45, this.eval_fig.pg005); 
               doc.text(70, 45, "07= "); 
               doc.text(83, 45, this.eval_fig.pg007);
               doc.text(90, 45, "09= "); doc.text(103, 45, this.eval_fig.pg009); doc.text(110, 45, "11= "); doc.text(123, 45, this.eval_fig.pg011);
               doc.text(130, 45, "13= "); doc.text(143, 45, this.eval_fig.pg013); doc.text(150, 45, "15= "); doc.text(163, 45, this.eval_fig.pg015);
               doc.text(170, 45, "17= "); doc.text(183, 45, this.eval_fig.pg017); 
               doc.line(10, 46, 190, 46);
               doc.text(10, 49, "19= "); doc.text(23, 49, this.eval_fig.pg019); doc.text(30, 49, "21= "); doc.text(43, 49, this.eval_fig.pg021);
               doc.text(50, 49, "23= "); doc.text(63, 49, this.eval_fig.pg023); doc.text(70, 49, "25= "); doc.text(83, 49, this.eval_fig.pg025);
               doc.text(90, 49, "27= "); doc.text(103, 49, this.eval_fig.pg027); doc.text(110, 49, "29= "); doc.text(123, 49, this.eval_fig.pg029);
               doc.text(130, 49, "31= "); doc.text(143, 49, this.eval_fig.pg031); doc.text(150, 49, "33= "); doc.text(163, 49, this.eval_fig.pg033);
               doc.text(170, 49, "35= "); doc.text(183, 49, this.eval_fig.pg035); 
               doc.line(10, 50, 190, 50);
               doc.text(10, 53, "37= "); doc.text(23, 53, this.eval_fig.pg037); doc.text(30, 53, "39= "); doc.text(43, 53, this.eval_fig.pg039);
               doc.text(50, 53, "41= "); doc.text(63, 53, this.eval_fig.pg041); doc.text(70, 53, "43= "); doc.text(83, 53, this.eval_fig.pg043);
               doc.text(90, 53, "45= "); doc.text(103, 53, this.eval_fig.pg045); doc.text(110, 53, "47= "); doc.text(123, 53, this.eval_fig.pg047);
               doc.line(10, 54, 130, 54);

               doc.line(10, 62, 190, 62);
               doc.text(10, 65, "02= "); doc.text(23, 65, this.eval_fig.pg002); doc.text(30, 65, "04= "); doc.text(43, 65, this.eval_fig.pg004);
               doc.text(50, 65, "06= "); doc.text(63, 65, this.eval_fig.pg006); doc.text(70, 65, "08= "); doc.text(83, 65, this.eval_fig.pg008);
               doc.text(90, 65, "10= "); doc.text(103, 65, this.eval_fig.pg010); doc.text(110, 65, "12= "); doc.text(123, 65, this.eval_fig.pg012);
               doc.text(130, 65, "14= "); doc.text(143, 65, this.eval_fig.pg014); doc.text(150, 65, "16= "); doc.text(163, 65, this.eval_fig.pg016);
               doc.text(170, 65, "18= "); doc.text(183, 65, this.eval_fig.pg018);
               doc.line(10, 66, 190, 66);
               doc.text(10, 69, "20= "); doc.text(23, 69, this.eval_fig.pg020); doc.text(30, 69, "22= "); doc.text(43, 69, this.eval_fig.pg022);
               doc.text(50, 69, "24= "); doc.text(63, 69, this.eval_fig.pg024); doc.text(70, 69, "26= "); doc.text(83, 69, this.eval_fig.pg026);
               doc.text(90, 69, "28= "); doc.text(103, 69, this.eval_fig.pg028); doc.text(110, 69, "30= "); doc.text(123, 69, this.eval_fig.pg030);
               doc.text(130, 69, "32= "); doc.text(143, 69, this.eval_fig.pg032); doc.text(150, 69, "34= "); doc.text(163, 69, this.eval_fig.pg034);
               doc.text(170, 69, "36= "); doc.text(183, 69, this.eval_fig.pg036);
               doc.line(10, 70, 190, 70);
               doc.text(10, 73, "38= "); doc.text(23, 73, this.eval_fig.pg038); doc.text(30, 73, "40= "); doc.text(43, 73, this.eval_fig.pg040);
               doc.text(50, 73, "42= "); doc.text(63, 73, this.eval_fig.pg042); doc.text(70, 73, "44= "); doc.text(83, 73, this.eval_fig.pg044);
               doc.text(90, 73, "46= "); doc.text(103, 73, this.eval_fig.pg046); doc.text(110, 73, "48= "); doc.text(123, 73, this.eval_fig.pg048);
               doc.line(10, 74, 130, 74);
          },
          ejeSinContestar: function () {

               this.ejeSinResponder = 0;
               console.log("1 ? ", this.ejemplo.pg001);
               if (this.ejemplo.pg001 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg002 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg003 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg004 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }
               if (this.ejemplo.pg005 === 0) { this.ejeSinResponder = this.ejeSinResponder + 1; }

               return this.ejeSinResponder;
          },
          sinContestar: function () {

               this.pregSinContestar = 0;
               // console.log("===============");
               // console.log("pg1 ? ", this.eval_fig.pg001, ", largo ?", this.eval_fig.pg001.length)
               if (this.eval_fig.pg001 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               // console.log("sin contestar ? ", this.pregSinContestar)
               if (this.eval_fig.pg002 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg003 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg004 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg005 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg006 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg007 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg008 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg009 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg010 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg011 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg012 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg013 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg014 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg015 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg016 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg017 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg018 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg019 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg020 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg021 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg022 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg023 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg024 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg025 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               if (this.eval_fig.pg026 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg027 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg028 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg029 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg030 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg031 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg032 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg033 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg034 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg035 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg036 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg037 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg038 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg039 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg040 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               if (this.eval_fig.pg041 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg042 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg043 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg044 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg045 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg046 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg047 === "") { this.pregSinContestar = this.pregSinContestar + 1; }
               if (this.eval_fig.pg048 === "") { this.pregSinContestar = this.pregSinContestar + 1; }

               return this.pregSinContestar;
          },
          addADayToMyDate() {
               if (this.eval_fecha) // as myDate can be null
                    // you have to set the this.myDate again, so vue can detect it changed
                    // this is not a caveat of this specific solution, but of any binding of dates
                    this.eval_fig.empezo = new Date(this.eval_fecha.setDate(this.eval_fecha.getDate() + 1));
          },
          dateToYYYYMMDD(date) {
               console.log("***********************************************************************************");
               console.log("Estoy en dateToYYYYMMDD ");
               console.log("date ? ", date, "; typeof ", typeof (date));
               console.log("date.toISOString().split('T')[0] ? ", date.toISOString().split('T')[0]);
               console.log("date && date.toISOString().split('T')[0] ?", date && date.toISOString().split('T')[0]);

               console.log("Desmenuzando ...");
               var a = date.toISOString();
               var b = a.split("T");
               var c = b[0];
               var d = b[1];
               console.log("a) date.toISOString() ", date.toISOString());
               console.log("b) ", a.split("T"));
               console.log("c) b[0]", b[0], "; b[1] ", b[1]);
               console.log("***********************************************************************************");

               // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
               return date && date.toISOString().split('T')[0]
          },
          cargaHora() {

               // Convierte la hora obtenida a hora local (utc)
               this.eval_fecha = new Date();
               var d = this.eval_fecha;
               var utcd = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(),
                    d.getMinutes(), d.getSeconds(), d.getMilliseconds());

               // obtain local UTC offset and convert to msec
               let localOffset = d.getTimezoneOffset() * 60000;
               var newdate = new Date(utcd + localOffset);
               var hours = newdate.getHours();
               var minutes = newdate.getMinutes();
               var seconds = newdate.getSeconds();
               var hora = hours + ":" + minutes + ":" + seconds;
               console.log("newdate ? ", newdate, " | ", hora);

               return hora;
          },
          cargaEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0,
               };

               this.eval_fig = store.state.st_ev05;        // Crea el nodo para todos los campos.
               this.res_fig = store.state.st_rs05;
               console.log("eva ? ", this.eval_fig);
               console.log("res ? ", this.res_fig);

               this.eval_fig.nombre = store.state.st_nusuario;    // Nombre del usuario que hará la evaluación
               this.eval_fig.empresa = store.state.st_empresa;     // Nombre de la empresa a la cual pertenece el usuario
               this.eval_fig.depto = store.state.st_depto;     // Nombre de la empresa a la cual pertenece el usuario
               this.eval_fig.sexo = store.state.st_sexo;     // Nombre de la empresa a la cual pertenece el usuario

               this.instrucciones = this.eval_fig.nombre.toUpperCase() + " haga click aqui para leer las instrucciones para responder la evaluación de PERFIL DE PERSONALIDAD."

               this.eval_fecha = new Date();                 // Fecha del Día
          },
          empezarEvaluacion() {

               this.eval_fig.empezo = this.cargaHora();
               this.inicioeval = true;
          },
          /** .................... VALIDACIONES  .................... */
          validarValor(valor) {
               let lvalor = valor;
               if (valor < 1 || valor > 2) {
                    lvalor = 0;
               }
               // console.log("validarValor, lvalor ? ",lvalor);
               return lvalor;
          },
          limpiarEvaluacion() {

               this.ejemplo = {
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0,
               };

               this.eval_fig = {
                    depto: "",
                    empresa: "", nombre: "",
                    fecha: "",
                    empezo: "", termino: "",
                    pg001: 0, pg002: 0, pg003: 0, pg004: 0, pg005: 0, pg006: 0, pg007: 0, pg008: 0, pg009: 0, pg010: 0,
                    pg011: 0, pg012: 0, pg013: 0, pg014: 0, pg015: 0, pg016: 0, pg017: 0, pg018: 0, pg019: 0, pg020: 0,
                    pg021: 0, pg022: 0, pg023: 0, pg024: 0, pg025: 0, pg026: 0, pg027: 0, pg028: 0, pg029: 0, pg030: 0,
                    pg031: 0, pg032: 0, pg033: 0, pg034: 0, pg035: 0, pg036: 0, pg037: 0, pg038: 0, pg039: 0, pg040: 0,
                    pg041: 0, pg042: 0, pg043: 0, pg044: 0, pg045: 0, pg046: 0, pg047: 0, pg048: 0, 

               }

               /* Variables para un nuevo caso */
               store.state.eval_fig = this.eval_fig;
          },
          /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
          /* Acciones del Floatting Button: Agregar Encuesta */
          agregarEvaluacion() {

               if (this.pregSinContestar > 0) {
                    alert("No es posible grabar la Evaluación. \nAún tiene " + this.pregSinContestar + " preguntas sin responder.   ")
                    return
               }

               this.finalizoeval = true;
               this.eval_fig.termino = this.cargaHora();

               this.eval_fecha = new Date();

               let ldia = this.eval_fecha.getDate();
               if (ldia <= 9) {
                    ldia = '0' + ldia.toString().trim();
               } else {
                    ldia = ldia.toString().trim();
               }
               let lmes = this.eval_fecha.getMonth() + 1;
               if (lmes <= 9) {
                    lmes = '0' + lmes.toString().trim();
               } else {
                    lmes = lmes.toString().trim();
               }
               console.log("dia ? ", ldia, ", mes ? ", lmes, ", anio ? ", this.eval_fecha.getFullYear());
               let lingreso = ldia + '/' + lmes + '/' + this.eval_fecha.getFullYear();


               console.log("*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-");
               console.log("** fecha de ingreso ? ", this.eval_fecha);
               console.log("** formato  ingreso ? ", lingreso);

               var confirma = confirm("Seguro de grabar la evaluación de PERFIL DE PERSONALIDAD para " + this.eval_fig.nombre.toUpperCase().trim() + " ?");
               if (confirma === true) {

                    /* Agrega una colección al objeto */
                    var dbEvaluaciones = store.state.st_dbEvalPerfil;
                    dbEvaluaciones.push({

                         empresa: this.eval_fig.empresa, nombre: this.eval_fig.nombre,
                         empezo: this.eval_fig.empezo, termino: this.eval_fig.termino,
                         fecha: lingreso, depto: this.eval_fig.depto, sexo: this.eval_fig.sexo,
                         pg001: this.eval_fig.pg001, pg002: this.eval_fig.pg002, pg003: this.eval_fig.pg003, pg004: this.eval_fig.pg004, pg005: this.eval_fig.pg005,
                         pg006: this.eval_fig.pg006, pg007: this.eval_fig.pg007, pg008: this.eval_fig.pg008, pg009: this.eval_fig.pg009, pg010: this.eval_fig.pg010,
                         pg011: this.eval_fig.pg011, pg012: this.eval_fig.pg012, pg013: this.eval_fig.pg013, pg014: this.eval_fig.pg014, pg015: this.eval_fig.pg015,
                         pg016: this.eval_fig.pg016, pg017: this.eval_fig.pg017, pg018: this.eval_fig.pg018, pg019: this.eval_fig.pg019, pg020: this.eval_fig.pg020,
                         pg021: this.eval_fig.pg021, pg022: this.eval_fig.pg022, pg023: this.eval_fig.pg023, pg024: this.eval_fig.pg024, pg025: this.eval_fig.pg025,
                         pg026: this.eval_fig.pg026, pg027: this.eval_fig.pg027, pg028: this.eval_fig.pg028, pg029: this.eval_fig.pg029, pg030: this.eval_fig.pg030,
                         pg031: this.eval_fig.pg031, pg032: this.eval_fig.pg032, pg033: this.eval_fig.pg033, pg034: this.eval_fig.pg034, pg035: this.eval_fig.pg035,
                         pg036: this.eval_fig.pg036, pg037: this.eval_fig.pg037, pg038: this.eval_fig.pg038, pg039: this.eval_fig.pg039, pg040: this.eval_fig.pg040,
                         pg041: this.eval_fig.pg041, pg042: this.eval_fig.pg042, pg043: this.eval_fig.pg043, pg044: this.eval_fig.pg044, pg045: this.eval_fig.pg045,
                         pg046: this.eval_fig.pg046, pg047: this.eval_fig.pg047, pg048: this.eval_fig.pg048, 
                    }).then((data) => {

                         /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                         this.limpiarEvaluacion();

                         var laClave = data.key;
                         this.grabado = true;
                         this.inicioeval = false;

                         // console.log("[culturaGforma- agregarEvaluacion], La clave almacenada es ? ",laClave);
                         alert("Evaluación de PERFIL DE PERSONALIDAD guardado con éxito.")
                    });
               } // if (confirma)
          }, // agregarEncuesta()

          //? =================================================================================
          enfoqueG1(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 2: //* Vengo de 1, voy a 2
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());

                         this.activott1="!active";
                         this.activott2="active";

                         this.vertt1=false;
                         this.vertt2=true;
                         break;
                    case 3: //* Vengo de 2, voy a 3
                         Vue.nextTick().then(()=> this.$refs.testtt3.focus());
                         this.activott2="!active";
                         this.activott3="active";

                         this.vertt2=false;                         
                         this.vertt3=true;
                         break;
                    case 4: //* Vengo de 3, voy a 4
                         Vue.nextTick().then(()=> this.$refs.testtt4.focus());
                         this.activott3="!active";
                         this.activott4="active";

                         this.vertt3=false;                         
                         this.vertt4=true;
                         break;
                    case 0: //* Vengo de 4, voy a 1
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());
                         this.activott4="!active";
                         this.activott1="active";

                         this.vertt4=false;
                         this.vertt1=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },
          nadaG1(pestana){
               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 1:
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());

                         this.activott1="active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="!active";

                         this.vertt1=true;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=false;

                         break;
                    case 2:
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());
                         this.activott1="!active";
                         this.activott2="active";
                         this.activott3="!active";
                         this.activott4="!active";

                         this.vertt1=false;
                         this.vertt2=true;
                         this.vertt3=false;
                         this.vertt4=false;

                         break;
                    case 3:
                         Vue.nextTick().then(()=> this.$refs.testtt3.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="active";
                         this.activott4="!active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=true;
                         this.vertt4=false;

                         break;
                    case 4:
                         Vue.nextTick().then(()=> this.$refs.testtt4.focus());
                         this.activott1="!active";
                         this.activott2="!active";
                         this.activott3="!active";
                         this.activott4="active";

                         this.vertt1=false;
                         this.vertt2=false;
                         this.vertt3=false;
                         this.vertt4=true;

                         break;
                    default:                         
                    // code block
               } //* switch
          },
          enfoqueRG1(pestana){

               //? Permite direccionar el cursor al campo cuyo ID='inputNombre'
               switch (pestana) {
                    case 3: //* Estoy en 4 regreso a 3
                         Vue.nextTick().then(()=> this.$refs.testtt3.focus());

                         this.activott4="!active";
                         this.activott3="active";

                         this.vertt4=false;
                         this.vertt3=true;
                         break;
                    case 2: //* Estoy en 3 regreso a 2
                         Vue.nextTick().then(()=> this.$refs.testtt2.focus());

                         this.activott3="!active";
                         this.activott2="active";

                         this.vertt3=false;
                         this.vertt2=true;
                         break;
                    case 1:   //* Estoy en 2 regreso a 1
                         Vue.nextTick().then(()=> this.$refs.testtt1.focus());
                         this.activott2="!active";
                         this.activott1="active";

                         this.vertt2=false;                         
                         this.vertt1=true;
                         break;
                    default:                         
                    // code block
               } //* switch
          },          
     }, // methods
} // export



// WEBPACK FOOTER //
// ./src/components/ev05_fig.js